import { render, staticRenderFns } from "./BsCardContent.vue?vue&type=template&id=173b2128&scoped=true&"
import script from "./BsCardContent.vue?vue&type=script&lang=js&"
export * from "./BsCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173b2128",
  null
  
)

export default component.exports